import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";

import { AddOnDialogSource } from "features/Settings/AddOns/schema";
import { trackEvent } from "utils/tracking";

interface Props {
  open: boolean;
  handleClose: () => void;
}

const UpgradeDialog = ({ open, handleClose }: Props) => {
  const { setAddOnDialogSource } = useContext(SubscriptionContext);

  const checkoutFromNeedsHelpDialog = () => {
    trackEvent("Get Offer Button Clicked from Onboarding Video");
    setAddOnDialogSource(AddOnDialogSource.get_started_video);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography variant="h6" textAlign="center">
          Upgrade Offer
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography sx={{ textAlign: "center" }}>
          Pay $50 to get a professional copywriter to write you a personalized
          (and non-AI sounding) template that you can use to send to thousands
          of brands!
        </Typography>
        <Grid container justifyContent="center" sx={{ my: 2 }}>
          <LoadingButton
            variant="contained"
            disableElevation
            onClick={checkoutFromNeedsHelpDialog}
          >
            Get Offer
          </LoadingButton>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeDialog;
